const balanceEnquiry = {
  request: {
    tran: "BALANCE ENQUIRY",
    amount: 1000,
    store: "RESTSIM00000001",
    pos: "57290093",
    chain: "Test",
    reference: "0611623e-929b-4cf1-a67b-636e287d262x",
  },

  response: {
    response_code: "00",
    response_text: "Approved",
    authID: "891633",
    amount: 1000,
    reference: "0611623e-929b-4cf1-a67b-636e287d262x",
    pos: "57290093",
    store: "RESTSIM00000001",
    tran: "BALANCE ENQUIRY",
    rrn: "000041290093",
    data: [],
    card: "476173******0010",
    ledger_balance: 10000,
    available_balance: 10000,
    card_name: "VISA CTLS",
    seq: "000041",
    sign: false,
    acc_type: "Credit",
    card_entry: "I",
    cryptogram_type: "TC",
    cryptogram: "4AD8878D11",
    tvr: "0000000000",
    aid: "A0000000041010",
    tsi: "F800",
    cvm_results: "440302",
    iad: "0810A74213023000000000000000000000FF",
    pin_statement: "Pin Verified",
    receipt: [],
  },
};

export default balanceEnquiry;
